import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/components/App/router";
import { initAnalytics } from "@/analytics";

import {
  backButton,
  init,
  locationManager,
  swipeBehavior,
  viewport,
} from "@telegram-apps/sdk-react";

function hasTgLaunchParamsInHash(): boolean {
  const h = window.location.hash || "";
  return h.includes("tgWebAppPlatform=") || h.includes("tgWebAppData=");
}

function mountTelegramSdkIfAvailable() {
  try {
    if (hasTgLaunchParamsInHash()) {
      init({ acceptCustomStyles: true });

      viewport.mount();
      swipeBehavior.mount();
      backButton.mount();
      locationManager.mount();
    }
  } catch (e) {
    console.warn("Telegram SDK init failed:", e);
  }
}

mountTelegramSdkIfAvailable();
initAnalytics();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

createRoot(rootElement).render(<RouterProvider router={router} />);
